export default __webpack_public_path__ + "static/media/blankCheck.9b9da363.png";